import { render, staticRenderFns } from "./index.html?vue&type=template&id=98f3c4f8&"
import script from "./ConfigAutoCreateStudentCode.vue?vue&type=script&lang=js&"
export * from "./ConfigAutoCreateStudentCode.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAutoCreateStudentCode.vue?vue&type=style&index=0&id=98f3c4f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports